import {FormModel} from '@xh/hoist/cmp/form';
import {HoistModel, managed, TaskObserver, XH} from '@xh/hoist/core';
import {Company, Roles} from '../../../../../data/DataTypes';
import {Icon} from '@xh/hoist/icon';

export class CompanyEditModel extends HoistModel {
    apiTask = TaskObserver.trackLast({message: 'Saving...'});
    @managed formModel = this.createFormModel();

    async load(id: number) {
        if (id) {
            const company = await XH.secMasterService.fetchSecurityCompanyByIdAsync(id);
            this.formModel.init(company ?? {});
        } else {
            this.formModel.init({});
        }
    }

    async save() {
        if (!XH.entitlementService.hasRole(Roles.SEC_MASTER_MANAGER)) {
            XH.dangerToast('You do not have permission to update.');
            return;
        }

        const company = await XH.secMasterService
            .saveCompanyAsync(this.company)
            .catchDefault({})
            .linkTo(this.apiTask);
        this.formModel.init(company);
    }

    revert() {
        XH.confirm({
            message: 'Undo all changes?',
            icon: Icon.question(),
            title: 'User confirmation required'
        }).then(result => {
            if (result) this.formModel.reset();
        });
    }

    get isVlid(): boolean {
        return this.formModel.isValid;
    }

    get hasChanges(): boolean {
        return this.formModel.isDirty;
    }

    get company(): Company {
        return this.formModel.getData() as Company;
    }

    private createFormModel() {
        return new FormModel({
            fields: [
                {name: 'securityId'},
                {name: 'ticker'},
                {name: 'subType'},
                {name: 'description'},
                {name: 'ceo'},
                {name: 'logoUrl'},
                {name: 'address'},
                {name: 'city'},
                {name: 'state'},
                {name: 'zip'},
                {name: 'employees'}
            ]
        });
    }
}
